import React, { useEffect, useState } from "react";

import * as N from "./userNftDetailElement";
import * as C from "components/common";
import * as D from "components/common/datatable/dataTableElements";

import transaction from "../../assets/transaction.png";

import logo from "assets/logo.svg";
import { useNavigate, useParams } from "react-router";
import { MainModel } from "components";
// redux slices
import {
  connectModelSlice,
  mainModel,
} from "store/redux/slices/helperSlices/modelSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  DeleteSellNftHook,
  GetNftTransactionHook,
  NFTTransactionsHook,
  UserNFTDetailsHook,
} from "hooks";
import { CommonUtility, ContractUtility } from "utility";
import { Loader } from "components/common";
import NftDetailsSidebar from "./userNftDetailSidebar";
import { GetNftByTokenIdHook, useWindowScrollPositions } from "hooks";
import { useSearchParams } from "react-router-dom";

import { AiFillHeart, AiOutlineShoppingCart } from "react-icons/all";
import {
  RowDivider,
  TopTransactionDiv,
  TransactionHistoryDiv,
} from "components/nftDetail/nftDetailsElement";
import { Panel } from "rsuite";

type Props = {
  nftDetailsContainer?: boolean;
  nftPriceCard?: boolean;
  buyNowBtn?: boolean;
  makeOfferBtn?: boolean;
  nFtPriceCardPrice?: boolean;
  mainTitle?: boolean;
  collectionDesc?: boolean;
  refetchFav?:any
};

const UserNftDetailComp: React.FC<Props> = ({refetchFav}) => {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const nftNetwork = searchParams.get("chain");
  const navigate = useNavigate();
  const { scrollX, scrollY } = useWindowScrollPositions();
  const [isMainSell, setIsMainSell] = useState(false);
  const [idObj, setIdObj] = useState(null);

  const { web3, account, chainId } = useAppSelector(
    (state) => state.web3Connect
  );

  //custom hooks
  const { data: transactionsData, fetchData } = NFTTransactionsHook();
  console.log(transactionsData, "transactionData")

  const {
    nftData,
    nftLoading,
    error: detailError,
    refetch: nftDataRefetch,
  } = UserNFTDetailsHook(
    ContractUtility.getNetwork(chainId),
    account && account,
    idObj?.tokenId,
    idObj?.tokenAddress
  );
  const { data, error, loading, getNft } = GetNftByTokenIdHook();

  const { getTx, data: tx, refetch } = GetNftTransactionHook();
  
  const {
    data: unlistData,
    loading: unlistLoading,
    deleteSellNft,
  } = DeleteSellNftHook();

  useEffect(() => {
    if (nftData) {
      getNft(params?.id);
      getTx(params?.id);
    }
  }, [nftData]);

  useEffect(() => {
    unlistData && refetch();
  }, [unlistData]);

  useEffect(() => {
    if (scrollY > 100) {
      setIsMainSell(true);
    } else {
      setIsMainSell(false);
    }
  }, [scrollY]);

  useEffect(() => {
    if (params && web3) {
      const idDestruct = CommonUtility.deStructureNftId(params?.id);
      setIdObj(idDestruct);
      fetchData(idDestruct?.tokenId, idDestruct?.tokenAddress);
    }
  }, [params, web3]);

  const handleNavigate = () => {
    if (tx?.status === "LISTED") {
      deleteSellNft(tx);
    } else {
      navigate(`/user-nft/${nftData?.id}/sell?chain=${chainId}`);
    }
  };

  return (
    <N.NftDetailsWrapper className="nftDetails">
      <MainModel />
      {nftLoading || (loading && <Loader content="Loading" />)}
      {unlistLoading && <Loader content="unlisting" />}
      {/*  */}
      {web3 && (
        <div style={{ position: "relative" }}>
          {detailError ? (
            <h1>{detailError}</h1>
          ) : (
            <>
              {/* <N.MainSell isMainSell={isMainSell}>
                <C.Buttons
                  disabled={unlistLoading ? true : false}
                  isSellBtn
                  onClick={() => handleNavigate()}
                >
                  {" "}
                  {tx?.status === "LISTED" ? "Unlist" : "Sell"}
                </C.Buttons>
              </N.MainSell> */}
              <C.MainContainer nftDetailsContainer>
                <div className="d-flex justify-content-end  mt-sm-3 mt-md-0">
                  <C.SocialMenu nftId={params?.id} refetchData={nftDataRefetch} />
                </div>

                <C.MainRow>
                  <C.MainCol lg={5}>
                    {nftData.token_id && (
                      <NftDetailsSidebar  data={{ ...nftData, ...data, refetchFav }} />
                    )}
                  </C.MainCol>

                  <C.MainCol lg={7}>
                    <C.MainRow>
                      <C.MainCol>
                        <N.CollectionTitles mainTitle>
                          {" "}
                          {data?.collection_name
                            ? data.collection_name
                            : nftData?.asset_contract?.name}
                        </N.CollectionTitles>
                        <N.CollectionTitles>
                          {data?.name ? data.name : nftData?.name} #
                          {idObj?.tokenId}
                        </N.CollectionTitles>
                        <N.PriceCardMain collectionDesc>
                          <N.Collectiondesc>
                            Owned by {CommonUtility.addressConvertor(account)}
                          </N.Collectiondesc>

                          <N.Collectionfavourite>
                            {" "}
                            {data?.favourites?.length} favorites <AiFillHeart />
                          </N.Collectionfavourite>
                        </N.PriceCardMain>
                        <C.Buttons
                          disabled={unlistLoading ? true : false}
                          isSellBtn
                          onClick={() => handleNavigate()}
                        >
                          {" "}
                          {tx?.status === "LISTED" ? "Unlist" : "Sell"}
                        </C.Buttons>
                      </C.MainCol>
                    </C.MainRow>

                    <C.MainRow>
                      <C.MainCol>
                        <TransactionHistoryDiv>
                          <Panel
                            header={
                              <N.CollapseHeader>
                                <img
                                  src={transaction}
                                  alt=""
                                  style={{
                                    transform: "translateY(5px)",
                                    // height: "rem",
                                  }}
                                />
                                <N.CollapseHeaderTitle>
                                  Transaction History
                                </N.CollapseHeaderTitle>
                              </N.CollapseHeader>
                            }
                            collapsible
                            bordered
                          >
                            <TopTransactionDiv>
                              <div className="transactionHeader">
                                <div>Event</div>
                                <div>Price</div>
                                <div>From</div>
                                <div>To</div>
                                <div>Tx Hash</div>
                                <div>Date</div>
                              </div>
                              <RowDivider />
                              <div className="transactionBody">
                                {transactionsData &&
                                  transactionsData.map((data, i) => {
                                    return (
                                      <div className="transactionItem">
                                        <div className="transactionBodyItem">
                                          {" "}
                                          <AiOutlineShoppingCart
                                            style={{
                                              marginRight: "5px",
                                              marginBottom: "3px",
                                            }}
                                          />
                                          {data.event}
                                        </div>
                                        <div className="price transactionBodyItem">
                                          <a href="#">{data.amount}</a>
                                        </div>
                                        <div className="transactionBodyItem">
                                          <a href="#">
                                            {CommonUtility.addressConvertor(
                                              data.from
                                            )}
                                          </a>
                                        </div>
                                        <div className="transactionBodyItem">
                                          <a href="#">
                                            {CommonUtility.addressConvertor(
                                              data.to
                                            )}
                                          </a>
                                        </div>
                                        <div className="transactionBodyItem">
                                          <a
                                            target="_blank"
                                            href={`${ContractUtility.getNetworkExplorer(
                                              nftNetwork.toString()
                                            )}/tx/${data.transactionHash}`}
                                          >
                                            {CommonUtility.addressConvertor(
                                              data.transactionHash
                                            )}
                                          </a>{" "}
                                        </div>
                                        <div className="transactionBodyItem">
                                          {" "}
                                          <a href="#" className="noLink">
                                            {CommonUtility.mm_dd_yy(
                                              data?.transactionDate
                                            )}
                                          </a>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </TopTransactionDiv>
                          </Panel>
                        </TransactionHistoryDiv>
                        {/* <C.MainCard nftPriceCard>
                          <C.NftCollapse
                            style={{
                              border: "1px solid black",
                            }}
                          >
                            <C.CollapsePanel
                              header={
                                <N.CollapseHeader>
                                  <img src={logo} width={20} alt="" />
                                  <N.CollapseHeaderTitle>
                                    Price History
                                  </N.CollapseHeaderTitle>
                                </N.CollapseHeader>
                              }
                              key="2"
                            >
                              <C.CardBody>
                                <D.DataTables
                                  value={transactionsData}
                                  dataKey="id"
                                  responsiveLayout="scroll"
                                >
                                  <D.Columns
                                    field="amount"
                                    header="Amount"
                                    sortable
                                    style={{ minWidth: "7rem" }}
                                  ></D.Columns>
                                  <D.Columns
                                    field="event"
                                    header="Event"
                                    sortable
                                    style={{ minWidth: "7rem" }}
                                  ></D.Columns>
                                  <D.Columns
                                    field="from"
                                    header="From"
                                    sortable
                                    body={(rowData) =>
                                      CommonUtility.addressConvertor(
                                        rowData.from
                                      )
                                    }
                                    style={{ minWidth: "7rem" }}
                                  ></D.Columns>
                                  <D.Columns
                                    field="to"
                                    header="To"
                                    sortable
                                    body={(rowData) =>
                                      CommonUtility.addressConvertor(rowData.to)
                                    }
                                    style={{ minWidth: "7rem" }}
                                  ></D.Columns>
                                  <D.Columns
                                    field="transactionDate"
                                    header="Transaction Date"
                                    sortable
                                    body={(rowData) =>
                                      CommonUtility.mm_dd_yy(
                                        rowData.transactionDate
                                      )
                                    }
                                    style={{ minWidth: "7rem" }}
                                  ></D.Columns>
                                  <D.Columns
                                    field="transactionHash"
                                    header="Transaction Hash"
                                    sortable
                                    body={(rowData) => (
                                      <a
                                        target="_blank"
                                        href={`${ContractUtility.getNetworkExplorer(
                                          nftNetwork.toString()
                                        )}/tx/${rowData.transactionHash}`}
                                      >
                                        {CommonUtility.addressConvertor(
                                          rowData.transactionHash
                                        )}
                                      </a>
                                    )}
                                    style={{ minWidth: "7rem" }}
                                  ></D.Columns>
                                </D.DataTables>
                              </C.CardBody>
                            </C.CollapsePanel>
                          </C.NftCollapse>
                        </C.MainCard> */}
                      </C.MainCol>
                    </C.MainRow>
                  </C.MainCol>
                </C.MainRow>
              </C.MainContainer>
            </>
          )}
        </div>
      )}
    </N.NftDetailsWrapper>
  );
};

export default UserNftDetailComp;
